import { ToastContainer } from 'react-toastify'

import { AppProvider } from '@/providers'
import Routes from '@/routes'

import './index.css'
import 'react-toastify/dist/ReactToastify.css'

export default function App() {
  return (
    <AppProvider>
      <Routes />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </AppProvider>
  )
}
